import * as React from 'react'
import styled from 'styled-components'

import LineAngleLeftBIcon from 'LuxKit/Icons/line/LineAngleLeftBIcon'
import LineAngleRightBIcon from 'LuxKit/Icons/line/LineAngleRightBIcon'
import type { SvgIconProps } from 'LuxKit/SvgIcon'
import Clickable from 'components/Common/Clickable'

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  iconprops?: SvgIconProps
}

const Arrow = styled(Clickable)`
  color: ${props => props.theme.palette.neutral.surface.darkContrast};
  pointer-events: all;
  opacity: .5;
  height: 100%;
`

const defaultIconProps = { height: 32, width: 16, type: 'secondary-dark' }

export function LeftArrow(props: Props) {
  const { iconprops = defaultIconProps, ...rest } = props
  return <Arrow {...rest}>
    <LineAngleLeftBIcon {...iconprops} />
  </Arrow>
}

export function RightArrow(props: Props) {
  const { iconprops = defaultIconProps, ...rest } = props
  return <Arrow {...rest}>
    <LineAngleRightBIcon {...iconprops} />
  </Arrow>
}
